module.exports = __webpack_public_path__ + "public/SiteImages/newsBoxBg.png?ef0b0a93";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/newsBoxBg.png
// module id = 1004
// module chunks = 8